import React, { Fragment } from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'
interface ApTextareaProps {
  name: string
  index: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  rules?: object
  disable?: boolean
}

const ApSelect: React.FC<ApTextareaProps> = ({ name, index, register, errors, rules, disable }) => {
  // console.log('KPI ERROR', { errors })
  // console.log('KPI ERROR', {
  //   errors: errors?.kpi && errors.kpi[0]?.manager_score?.message,
  // })
  return (
    <Fragment>
      <select
        {...register(name, rules)}
        className={`form-control ap-select kpi-input-select h-100 ${
          errors && errors.kpi && errors.kpi[index]?.employee_score ? 'is-invalid w-100' : ''
        }`}
        disabled={disable}
      >
        <option value={''}>-</option>
        <option value={1}>1</option>
        <option value={2}>2</option>
        <option value={3}>3</option>
        <option value={4}>4</option>
        <option value={5}>5</option>
        <option value={6}>6</option>
        <option value={7}>7</option>
        <option value={8}>8</option>
        <option value={9}>9</option>
        <option value={10}>10</option>
      </select>
      {errors && errors.kpi && (
        <div className='invalid-feedback'>{errors.kpi[index]?.employee_score?.message}</div>
      )}
      {errors && errors.kpi && (
        <div className='invalid-feedback'>{errors.kpi[index]?.manager_score?.message}</div>
      )}
    </Fragment>
  )
}

export default ApSelect
